import "../../style/pages/NoPage.scss";

export default function NoPage() {
    return (
        <div className="no-page">
            <p>Geen pagina gevonden. Klik op een van de navigatie knoppen om naar een bestaande pagina te gaan.</p>
        </div>
    );
}
